<script setup lang="ts">
import IconBase from '../IconBase.vue';

const props = withDefaults(
  defineProps<{
    fill?: string;
  }>(),
  { fill: 'currentColor' },
);
</script>

<template>
  <IconBase>
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.25 0C8.78679 0 10.0745 1.06665 10.413 2.5H19.25C19.6642 2.5 20 2.83579 20 3.25C20 3.66421 19.6642 4 19.25 4H10.413C10.0745 5.43335 8.78679 6.5 7.25 6.5C5.71321 6.5 4.42555 5.43335 4.08697 4H0.75C0.335786 4 0 3.66421 0 3.25C0 2.83579 0.335786 2.5 0.75 2.5H4.08697C4.42555 1.06665 5.71321 0 7.25 0ZM5.5 3.25C5.5 4.2165 6.2835 5 7.25 5C8.2165 5 9 4.2165 9 3.25C9 2.2835 8.2165 1.5 7.25 1.5C6.2835 1.5 5.5 2.2835 5.5 3.25Z"
        :fill="fill"
      />
      <path
        d="M9.58697 12H0.75C0.335786 12 0 12.3358 0 12.75C0 13.1642 0.335786 13.5 0.75 13.5H9.58697C9.92555 14.9334 11.2132 16 12.75 16C14.2868 16 15.5745 14.9334 15.913 13.5H19.25C19.6642 13.5 20 13.1642 20 12.75C20 12.3358 19.6642 12 19.25 12H15.913C15.5745 10.5666 14.2868 9.5 12.75 9.5C11.2132 9.5 9.92555 10.5666 9.58697 12ZM11 12.75C11 11.7835 11.7835 11 12.75 11C13.7165 11 14.5 11.7835 14.5 12.75C14.5 13.7165 13.7165 14.5 12.75 14.5C11.7835 14.5 11 13.7165 11 12.75Z"
        :fill="fill"
      />
    </svg>
  </IconBase>
</template>
